import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {deserialize} from '@dhkatz/json-ts';
import {JsonObject} from '@dhkatz/json-ts/typings/util';
import {Observable} from 'rxjs/internal/Observable';
import {map} from 'rxjs/operators';
import {InteractiveResponse} from '../data/interactive-response';
import {InteractiveEndpoints} from '../interactive-endpoints';
import {deserializeFix} from '../../../../../../utils/deserialize-util';

@Injectable({
  providedIn: 'root'
})
export class InteractiveService {

  public constructor(private readonly _http: HttpClient) { //
  }

  public getInteractive(projectId: string): Observable<InteractiveResponse> {
    return this._http.get<JsonObject>(InteractiveEndpoints.INTERACTIVE.replace(InteractiveEndpoints.PROJECT_ID, projectId))
      .pipe(map((response: JsonObject) => deserializeFix(InteractiveResponse, response)));
  }

  public getInteractivePreview(versionId: string): Observable<InteractiveResponse> {
    return this._http.get<JsonObject>(InteractiveEndpoints.INTERACTIVE_PREVIEW
      .replace(InteractiveEndpoints.VERSION_ID, versionId))
      .pipe(map((response: JsonObject) => deserializeFix(InteractiveResponse, response)));
  }
}
